import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import Header from "@components/Header/Header";
import MetaTags from "@components/MetaTags/MetaTags";
import EventsAwardsFooter from "@events-awards/components/EventsAwardsFooter";
import EventsAwardsLogoMenu from "@events-awards/components/EventsAwardsLogoMenu";
import EventsAwardsNews from "@events-awards/EventsAwardsNews";
import { AWARDS_EVENTS_PAGE_ROW_DATA } from "@events-awards/utils/constants";
import {
  AwardType,
  EventsAwardsWinnersContextData,
} from "@events-awards/utils/types";
import { cn } from "@util/helpers";
import { useDetectAdBlock } from "adblock-detect-react";

/**
 * Component to render SIA news page content
 */
const EventsAwardsNewsPageContent = ({
  title,
  articles,
  awardType,
}: EventsAwardsWinnersContextData): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  const isSIAAward = awardType === AwardType.SIA;
  const awardData = AWARDS_EVENTS_PAGE_ROW_DATA.find(
    (data) => data.awardType === awardType
  );
  const awardPath = awardData?.blockTitleProps?.link || "";

  return (
    <div
      className="min-h-screen w-full bg-gray-50"
      data-testid="events-news-page-component"
    >
      <AdSettings
        adNames={["lb1", "prestitial", "catfish", "abm"]}
        path={`${awardPath}/news`}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title={`${awardData?.blockTitleProps?.text} News`}
        level2="events news"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={title || "The Business Times"}
        description={`The Business Times ${awardData?.blockTitleProps?.text} - ${awardData?.description}`}
        ogType="website"
        slug={awardPath}
      />

      <Ad
        adType="lb1"
        className="flex min-h-[50px] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[250px]"
      />

      <Header />

      <Container>
        <Row rootClassName="justify-center">
          <Column
            rootClassName={cn("w-full lg:w-8/12 my-8", {
              "lg:w-10/12": isSIAAward,
            })}
          >
            {awardType ? <EventsAwardsLogoMenu awardType={awardType} /> : null}

            <EventsAwardsNews
              articles={articles}
              title="test"
              awardType={awardType}
            />
          </Column>
        </Row>
      </Container>

      <EventsAwardsFooter awardType={awardType} />

      <Ad adType="catfish" />

      <Ad adType="abm" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsNewsPageContent;
